var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"op-pill",style:({ '--c': _vm.style.hex, '--t': _vm.style.text })},[_c('font-awesome-icon',{attrs:{"icon":_vm.style.icon}}),_vm._v(_vm._s(_vm.option.title)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }